import * as React from 'react';

import {
  DrawerContext,
  IconRegularClose,
  ModalContext,
} from '@notino/react-styleguide';

import { useIsDesktop } from '@utils/helpers';

import { trackCloseDrawerOrModal } from '../../../tracking';

import loyaltyDesktop from './assets/loyaltyDesktop.webp';
import loyaltyMobile from './assets/loyaltyMobile.webp';
import { CloseIconWrapper, HeaderWrapper, Image } from './styled';

export const Header = () => {
  const { closeDrawer } = DrawerContext.useDrawerContext();
  const { toggleModal } = ModalContext.useModalContext();

  const isDesktop = useIsDesktop();

  const handleClose = () => {
    trackCloseDrawerOrModal({ isOutsideClick: false });

    if (isDesktop) {
      toggleModal();
      return;
    }
    closeDrawer();
  };

  return (
    <HeaderWrapper>
      <Image
        src={isDesktop ? loyaltyDesktop : loyaltyMobile}
        alt="loyalty program"
      />
      <CloseIconWrapper onClick={handleClose}>
        <IconRegularClose
          color="icon.inverse"
          width="1.25rem"
          height="1.25rem"
        />
      </CloseIconWrapper>
    </HeaderWrapper>
  );
};
